import { useEffect, useMemo, useState } from "react";

export type Mode = "system" | "light" | "dark";
const KEY = "app:colorMode";

export const useColorMode = (defaultMode: Mode = "system") => {
  const [mode, setMode] = useState<Mode>(() => {
    try {
      return (localStorage.getItem(KEY) as Mode) || defaultMode;
    } catch {
      return defaultMode;
    }
  });
  const [systemDark, setSystemDark] = useState<boolean>(
    () =>
      typeof window !== "undefined" &&
      window.matchMedia?.("(prefers-color-scheme: dark)").matches
  );

  useEffect(() => {
    localStorage.setItem(KEY, mode);
  }, [mode]);

  useEffect(() => {
    const mq = window.matchMedia?.("(prefers-color-scheme: dark)");
    if (!mq) return;
    const onChange = (e: MediaQueryListEvent) => setSystemDark(e.matches);
    mq.addEventListener?.("change", onChange);
    return () => mq.removeEventListener?.("change", onChange);
  }, []);

  const isDark = useMemo(
    () => mode === "dark" || (mode === "system" && systemDark),
    [mode, systemDark]
  );

  return { mode, setMode, isDark };
};
